import { getCleanBrandNames } from "../../utilities";
import Cookies from "js-cookie";
// import { receiveServerErrors } from '../errors/error_actions';
// import { receiveCurrentSession } from '../entry/session_actions';
// import { receiveServerMessage } from '../server_messages/server_message_actions';
import {
  receiveInfluencerVideos as receiveVideos,
  receiveGameVideos,
} from "../Home/home_actions";

export const REQUEST_INFLUENCERS = "REQUEST_INFLUENCERS";
export const RECEIVE_INFLUENCERS = "RECEIVE_INFLUENCERS";
export const UPDATE_INFLUENCER_PARAMS = "UPDATE_INFLUENCER_PARAMS";
export const RECEIVE_INFLUENCER = "RECEIVE_INFLUENCER";
export const RECEIVE_INFLUENCER_VIDEOS = "RECEIVE_INFLUENCER_VIDEOS";
export const RECEIVE_INFLUENCER_PRODUCTS = "RECEIVE_INFLUENCER_PRODUCTS";
export const RECEIVE_INFLUENCER_BRANDS = "RECEIVE_INFLUENCER_BRANDS";
export const REQUEST_INFLUENCER_BRANDS = "REQUEST_INFLUENCER_BRANDS";
export const REQUEST_INFLUENCER_VIDEOS = "REQUEST_INFLUENCER_VIDEOS";
export const REQUEST_INFLUENCER_PRODUCTS = "REQUEST_INFLUENCER_PRODUCTS";
export const FINDING_VIDEOS = "FINDING_VIDEOS";
export const REQUEST_INFLUENCER_USER = "REQUEST_INFLUENCER_USER";
export const RECEIVE_INFLUENCER_USER = "RECEIVE_INFLUENCER_USER";
export const REQUEST_INFLUENCER_DEMOGRAPHICS =
  "REQUEST_INFLUENCER_DEMOGRAPHICS";
export const RECEIVE_INFLUENCER_DEMOGRAPHICS =
  "RECEIVE_INFLUENCER_DEMOGRAPHICS";
export const REQUEST_INFLUENCER_SENTIMENT = "REQUEST_INFLUENCER_SENTIMENT";
export const RECEIVE_INFLUENCER_SENTIMENT = "RECEIVE_INFLUENCER_SENTIMENT";
export const REQUEST_INFLUENCER_DAILY_TRACKINGS =
  "REQUEST_INFLUENCER_DAILY_TRACKINGS";
export const RECEIVE_INFLUENCER_DAILY_TRACKINGS =
  "RECEIVE_INFLUENCER_DAILY_TRACKINGS";
export const RESET_FILTERS_INFLUENCERS = "RESET_FILTERS_INFLUENCERS";
export const INFLUENCER_PAGE_STATES = "INFLUENCER_PAGE_STATES";

const lodash = require("lodash");
export const doResetFiltersInfluencers = () => ({
  type: RESET_FILTERS_INFLUENCERS,
});

const requestInfluencers = () => ({ type: REQUEST_INFLUENCERS });

const requestInfluencerVideos = (id) => ({
  type: REQUEST_INFLUENCER_VIDEOS,
  id,
});

const requestInfluencerProducts = (id) => ({
  type: REQUEST_INFLUENCER_PRODUCTS,
  id,
});

const requestInfluencerBrands = () => ({
  type: REQUEST_INFLUENCER_BRANDS,
});

const setFindingVideos = (findingVideos) => ({
  type: FINDING_VIDEOS,
  findingVideos,
});

export const requestInfluencerUser = () => ({ type: REQUEST_INFLUENCER_USER });

export const receiveInfluencerUser = (user) => ({
  type: RECEIVE_INFLUENCER_USER,
  user,
});

export const updateInfluencerPageState = (status) => ({
  type: INFLUENCER_PAGE_STATES,
  status,
});

const requestInfluencerDemographics = () => ({
  type: REQUEST_INFLUENCER_DEMOGRAPHICS,
});

const receiveInfluencerDemographics = (demographics) => ({
  type: RECEIVE_INFLUENCER_DEMOGRAPHICS,
  demographics,
});

const requestInfluencerSentiment = () => ({
  type: REQUEST_INFLUENCER_SENTIMENT,
});

const receiveInfluencerSentiment = (sentiment) => ({
  type: RECEIVE_INFLUENCER_SENTIMENT,
  sentiment,
});

const requestInfluencerDailyTracking = () => ({
  type: REQUEST_INFLUENCER_DAILY_TRACKINGS,
});

const receiveInfluencerDailyTracking = (engagementIndex) => ({
  type: RECEIVE_INFLUENCER_DAILY_TRACKINGS,
  engagementIndex,
});

const receiveInfluencers = ({ influencers, data }) => ({
  type: RECEIVE_INFLUENCERS,
  influencers,
  data: getCleanBrandNames(data),
});

export const updateParams = (params) => ({
  type: UPDATE_INFLUENCER_PARAMS,
  params,
});

const receiveInfluencer = ({ influencer, statistics }) => ({
  type: RECEIVE_INFLUENCER,
  influencer,
  statistics,
});

const receiveInfluencerVideos = (videos) => ({
  type: RECEIVE_INFLUENCER_VIDEOS,
  videos,
});

const receiveInfluencerProducts = ({ products, pictures, categories }) => ({
  type: RECEIVE_INFLUENCER_PRODUCTS,
  products,
  pictures,
  categories,
});

const receiveInfluencerBrands = ({ creatorBrands }) => ({
  type: RECEIVE_INFLUENCER_BRANDS,
  creatorBrands,
});

export const fetchInfluencers = (data) => (dispatch) => {
  dispatch(requestInfluencers());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers`,
    data: {
      ...data,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(response) {
      dispatch(receiveInfluencers(response));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchInfluencer = (id) => (dispatch) => {
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers/${id}`,
    success(influencer) {
      dispatch(receiveInfluencer(influencer));
      dispatch(fetchInfluencerUser(influencer));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchInfluencerVideos = (id) => (dispatch) => {
  dispatch(requestInfluencerVideos(id));
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers/${id}/videos`,
    success(videos) {
      dispatch(receiveInfluencerVideos(videos));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchInfluencerProducts = (id) => (dispatch) => {
  dispatch(requestInfluencerProducts(id));
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers/${id}/products`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(products) {
      dispatch(receiveInfluencerProducts(products));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchInfluencerBrands = (id) => (dispatch) => {
  dispatch(requestInfluencerBrands());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers/${id}/get_list_of_brands_associated_with_creator`,
    success(data) {
      dispatch(receiveInfluencerBrands({ creatorBrands: data.brands || [] }));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const findInfluencerVideos = (id) => (dispatch) => {
  dispatch(setFindingVideos(true));
  $.ajax({
    method: "put",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers/${id}`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success({ influencer, videos, totalVideos }) {
      // dispatch(receiveCurrentSession({ influencer }));
      dispatch(receiveVideos(videos));
      dispatch(
        receiveGameVideos({
          gameVideos: videos,
          gameCount: videos.length,
          gamePages: 1,
        })
      );
      // dispatch(receiveServerMessage(`${videos.length} of ${totalVideos} videos added.`));
      dispatch(setFindingVideos(false));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchInfluencerUser = (influencer) => (dispatch) => {
  dispatch(requestInfluencerUser());
  const data = {
    video_author_id: lodash.get(influencer, "influencer._id", influencer._id),
    brand_id: Cookies.get("bId"),
    user_id: Cookies.get("uId"),
  };
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/users/`,
    data,
    success(response) {
      dispatch(receiveInfluencerUser(response));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchInfluencerDemographics = (id) => (dispatch) => {
  dispatch(requestInfluencerDemographics());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers/${id}/demographics/`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(demographics) {
      dispatch(receiveInfluencerDemographics(demographics));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchInfluencerSentiment = (id) => (dispatch) => {
  dispatch(requestInfluencerSentiment());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers/${id}/sentiment`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(sentiment) {
      dispatch(receiveInfluencerSentiment(sentiment));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const fetchInfluencerDailyTrackings = (id) => (dispatch) => {
  dispatch(requestInfluencerDailyTracking());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/influencers/${id}/influencer_daily_trackings`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(engagementIndex) {
      dispatch(receiveInfluencerDailyTracking(engagementIndex));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};
